import { render, staticRenderFns } from "./MapPrice.vue?vue&type=template&id=a70a5dfe&"
import script from "./MapPrice.vue?vue&type=script&lang=js&"
export * from "./MapPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports